import _ from 'lodash';
import React from 'react';
import classNames from 'classnames';

import {resizeImageWithImgix} from 'utils/images';

import Dropdown from 'components/Dropdown';
import Avatar from 'components/Avatar';
import Warning from 'components/Warning';
import {ErrorField} from 'components/Fields';

import arrowDownIcon from 'assets/icons/arrow-down.svg';
import arrowRightIcon from 'assets/icons/arrow-right.svg';

import './styles.css';

const Placeholder = ({onClick}) => (
  <div
    className="RoomTypeSelect__Option colab-row-space-between colab-small-border-radius colab-clickable colab-centered-v"
    onClick={onClick}
    data-dropdowntrigger="roomTypeSelect">
    <div className="RoomTypeSelect__Option__default_label">
      Select room type ...
    </div>
    <div className="colab-centered RoomTypeSelect__Option--icon">
      <img src={arrowDownIcon} alt="arrowDown" />
    </div>
  </div>
);

const OptionContent = ({option, description}) => {
  const roomTypes = _.get(option, 'roomTypes');
  const imageURL = option.url || (roomTypes && roomTypes[0].url);

  return (
    <div className="colab-centered-v">
      <Avatar
        url={resizeImageWithImgix(imageURL, {fit: 'crop', w: 200, h: 200})}
        initials=""
      />
      <div className="colab-sidepadding-1">
        <div className="RoomTypeSelect__Option__label colab-bold">
          {option.label}
        </div>
        <div className="RoomTypeSelect__Option__description">{description}</div>
      </div>
    </div>
  );
};

const SelectedOption = ({onClick, option, disabled, clearOption}) => (
  <div
    className={classNames(
      'RoomTypeSelect__Option colab-row-space-between colab-small-border-radius colab-clickable colab-centered-v',
      {'RoomTypeSelect__Option--disabled': disabled}
    )}
    onClick={onClick}
    data-dropdowntrigger="roomTypeSelect">
    <OptionContent option={option} description={option.capacity} />
    <div className=" colab-centered-v">
      <div
        className="colab-centered RoomTypeSelect__Option--icon"
        onClick={clearOption}>
        x
      </div>
      <div className="colab-centered RoomTypeSelect__Option--icon">
        <img src={arrowDownIcon} alt="arrowDown" />
      </div>
    </div>
  </div>
);

const RoomTypeOption = ({onClick, option, description}) => (
  <div
    className="RoomTypeSelect__Option--sub colab-clickable colab-centered-v"
    onClick={() => onClick(option)}>
    <OptionContent option={option} description={description} />
  </div>
);

const RoomTypeGroupOption = ({onClick, option, description, sectionOpened}) => (
  <div
    className="RoomTypeSelect__Option colab-clickable colab-centered-v"
    onClick={() => onClick(option)}>
    {!sectionOpened && <img src={arrowDownIcon} alt="arrowDown" />}
    {sectionOpened && <img src={arrowRightIcon} alt="arrowRight" />}
    <OptionContent option={option} description={description} />
  </div>
);

class RoomTypeSelect extends React.Component<any> {
  state = {
    sectionOpened: false,
    subsectionsOpened: [],
    position: {left: 0, top: 0}
  };

  toggleSubsection = option => {
    this.setState({
      subsectionsOpened: _.xor(this.state.subsectionsOpened, [option.label])
    });
  };

  toggleSection = event => {
    const position = event.currentTarget.getBoundingClientRect();

    this.setState({
      position: {top: position.bottom},
      sectionOpened: !this.state.sectionOpened
    });
  };

  onChange = option => {
    this.props.input.onChange(option);
    this.closePopup();
  };

  closePopup = () => {
    this.setState({sectionOpened: false});
  };

  clearOption = () => {
    this.props.input.onChange(null);
  };

  render() {
    const {
      groupedRoomTypes,
      meta: {touched, error, warning},
      disabled
    } = this.props;

    const selectedOption = this.props.input.value;

    return (
      <div className="RoomTypeSelect">
        {!selectedOption && <Placeholder onClick={this.toggleSection} />}
        {selectedOption && (
          <SelectedOption
            option={selectedOption}
            onClick={this.toggleSection}
            disabled={disabled}
            clearOption={this.clearOption}
          />
        )}

        <Dropdown
          isOpen={this.state.sectionOpened}
          position={this.state.position}
          onClose={this.closePopup}
          triggerKey="roomTypeSelect"
          className="RoomTypeSelect__dropdown colab-small-border-radius">
          {this.state.sectionOpened &&
            groupedRoomTypes.map(roomTypeGroup => {
              const sectionOpened = _.includes(
                this.state.subsectionsOpened,
                roomTypeGroup.label
              );
              return (
                <div
                  key={roomTypeGroup.value}
                  className="RoomTypeSelect__dropdown__group">
                  <RoomTypeGroupOption
                    option={roomTypeGroup}
                    onClick={this.toggleSubsection}
                    description={`${roomTypeGroup.roomTypes.length} variations`}
                    sectionOpened={sectionOpened}
                  />
                  <div>
                    {sectionOpened &&
                      roomTypeGroup.roomTypes.map(roomType => (
                        <RoomTypeOption
                          key={roomType.value}
                          option={roomType}
                          onClick={this.onChange}
                          description={roomType.capacity}
                        />
                      ))}
                  </div>
                </div>
              );
            })}
        </Dropdown>

        <ErrorField touched={touched} error={error} />
        {warning && <Warning>{warning}</Warning>}
      </div>
    );
  }
}

export default RoomTypeSelect;
